import { useEffect, useMemo, useState } from 'react'

import { getTimerDurations, TIMER_STATUS } from '../model/activityTimerSlice'
import useActivityTimer from './useActivityTimer'

export default function useActivityTimerClock() {
  const timer = useActivityTimer()
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    setNow(Date.now())
    if (timer.status !== TIMER_STATUS.RUNNING) return undefined

    const intervalId = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(intervalId)
  }, [timer.endedAt, timer.focusStartedAt, timer.startedAt, timer.status])

  return useMemo(() => ({
    ...timer,
    ...getTimerDurations(timer, now),
  }), [now, timer])
}
